import { render, staticRenderFns } from "./draughtFan.vue?vue&type=template&id=d80d935a"
import script from "./draughtFan.vue?vue&type=script&lang=js"
export * from "./draughtFan.vue?vue&type=script&lang=js"
import style0 from "./draughtFan.vue?vue&type=style&index=0&id=d80d935a&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports